import IProduct from "../entities/IProduct";
import { IMedia } from "../entities/IMedia";
import Axios from "./Axios";
import { get } from "./HttpApi";
import ENDPOINTS from "./endpoints";

const getAll = async (): Promise<Array<IProduct>> => {
  return await get(ENDPOINTS.products.all).then((res) => res);
};

  async function getAllProduct() {

    return new Promise((resolve) =>  {
      setTimeout(() => resolve(get(ENDPOINTS.products.all)), 200);
    });
  }

  const getProducts = () =>{
    return Axios.get<Array<IProduct>>(ENDPOINTS.products.all) ;
  }

  type ProductFilterParams = {
    page?: number;
    size?: number;
    title?: string;
    categoryId?: number | string;
    product_type?: string;
    estatusId?: number | string;
    vendorId?: number | string;
    [key: string]: any;
  };

  const filterProducts = (params: ProductFilterParams = {}) => {
    const { page = 0, size = 20, ...rest } = params;
    return Axios.get<any>(ENDPOINTS.products.filter, {
      params: { page, size, ...rest },
    });
  };

  const createProduct = (data: IProduct)=> {
    return Axios.post<IProduct>(ENDPOINTS.products.create, data);
  }

  const updateProduct = (id: number, data: IProduct) => {
    return Axios.put<IProduct>(ENDPOINTS.products.update(id), data);
  }

  const getProductById = (id: number) => {
    return Axios.get<IProduct>(ENDPOINTS.products.byId(id));
  };

  const deleteProduct = (id: number) => {
    return Axios.delete(ENDPOINTS.products.delete(id));
  };

  const updateThumbnail = (productId: number, thumbnail: string) => {
    return Axios.patch(ENDPOINTS.products.updateThumbnail(productId), { thumbnail });
  };

  const createMedia = (data: IMedia[])=> {
    return Axios.post<Array<IMedia>>(ENDPOINTS.media.create, data);
  }

  const upload = (file: File, productId: number, onUploadProgress: any):
    Promise<any> => {
    const formData = new FormData();
    formData.append(
      "data",
      JSON.stringify({
        filename: file.name,
        size: file.size,
        mediaType: file.type,
        entityId: productId,
      })
    );
    formData.append("file", file);
    return Axios.post(ENDPOINTS.media.upload, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    });
  };

  const getFiles = (productId: number) : Promise<any> => {
    return Axios.get(ENDPOINTS.media.productFiles(productId));
  };

  const deleteMedia = (mediaId: number) : Promise<string> => {
    return Axios.delete(ENDPOINTS.media.byId(mediaId));
  }

  const updateMedia = (mediaId: number) : Promise<IMedia> => {
    return Axios.put(ENDPOINTS.media.byId(mediaId));
  }

  const ProductServiceApi = {
    getAll,
    get,
    getAllProduct,
    createProduct,
    updateProduct,
    deleteProduct,
    updateThumbnail,
    getProductById,
    getProducts,
    filterProducts,
    createMedia,
    upload,
    getFiles,
    deleteMedia,
    updateMedia,
  };

  export default ProductServiceApi;